<template>
    <az-modal v-if="exibirMensagem" :maxWidth="tamanhoMaximo">
        <span slot="title">{{ titulo }}</span>

        <div slot="body" class="mensagem-confirmacao__texto px-1">
            <h4 v-if="textoPrimario" class="mb-1">
                <strong>{{ textoPrimario }}</strong>
            </h4>

            <p v-if="textoSecundario" class="mensagem-confirmacao__texto-secundario">
                {{ textoSecundario }}
            </p>
        </div>

        <div class="mensagem-confirmacao__acao" slot="actions">
            <az-call-to-action id="botaoRecusar" @click="$emit('recusado')" slot="actions"
                               css-class="botao">
                {{ botaoRecusar }}
            </az-call-to-action>

            <az-call-to-action id="botaoConfirmar" @click="$emit('confirmado')" slot="actions"
                               css-class="botao-primario">
                {{ botaoConfirmar }}
            </az-call-to-action>
        </div>
    </az-modal>
</template>

<script>
export default {
    name: 'MensagemConfirmacao',
    props: {
        exibirMensagem: {
            type: Boolean,
            default: false
        },
        titulo: {
            type: String,
            default: 'Excluir'
        },
        textoPrimario: {
            type: String,
            default: ''
        },
        textoSecundario: {
            type: String,
            default: 'Deseja realmente excluir?'
        },
        botaoRecusar: {
            type: String,
            default: 'Não'
        },
        botaoConfirmar: {
            type: String,
            default: 'Sim'
        },
        tamanhoMaximo: {
            type: String,
            default: '290'
        }
    }
}
</script>

<style scoped lang="stylus">
    .mensagem-confirmacao
        &__texto
            text-align center
            color #777

        &__texto-secundario
            width 80%
            margin 0 auto

        &__acao
            text-align center
            margin-bottom 16px

            .botao
                color #777 !important
                border 0

            .botao:first-child
                margin-right 10px

            .botao-primario, .botao
                text-transform uppercase
                font-size 13px

            .botao-primario
                background-color #7aa329 !important
                color #fff !important
                border 1px solid #7aa329
</style>